<template>
  <div :class="`toast ${type}`">{{ text }}</div>
</template>

<script setup>
  import { useToastStore } from '../stores/toast_store';
  const { text, type } = useToastStore();
</script>